import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon.js';
import HubTabs from './HubTabs.js';

/**
 * A page: optional back link, large title (34px), one sub line, actions on
 * the right (icon buttons). Every route uses this instead of rolling its own
 * header, so titles line up across the app. A page inside a hub (nav.ts)
 * gets the hub's tab strip under its header; detail pages (with `back`) don't.
 */
export default function Page({
  title,
  sub,
  actions,
  back,
  wide = false,
  narrow = false,
  className,
  children,
}: {
  title: string;
  sub?: ReactNode;
  actions?: ReactNode;
  back?: { to: string; label: string };
  /** Work pages (Today, workspaces, projects, the board): fluid up to ~2000px on desktop. */
  wide?: boolean;
  /** Long-form pages (forms, settings): a ~680px reading column. */
  narrow?: boolean;
  className?: string;
  children?: ReactNode;
}): JSX.Element {
  return (
    <div className={`ui-page${wide ? ' ui-page--wide' : narrow ? ' ui-page--narrow' : ''}${className ? ` ${className}` : ''}`}>
      {back && (
        <Link to={back.to} className="ui-back">
          <Icon name="chevron-left" size={22} />
          {back.label}
        </Link>
      )}
      <header className="page-head ui-head">
        <div className="ui-head__main">
          <h1 className="page-head__title">{title}</h1>
          {sub && <p className="page-head__sub">{sub}</p>}
        </div>
        {actions && <div className="ui-head__actions">{actions}</div>}
      </header>
      {!back && <HubTabs />}
      {children}
    </div>
  );
}
